import UserTypes from "venuescanner-js/constants/user_type";
const setMethods = (model) => {
  // model.UserType = (user) => {
  //   // sample method, not tested
  //   const userId = (typeof user === 'string') ? user : (
  //     typeof user.data === 'function' ? user.data()._id : user._id
  //   )
  //   return (model._subjects._value.organiser._id === userId) ? UserTypes.organiser : UserTypes.host
  // }
};
export default setMethods;
